import { IconButton } from "@carbon6/c6-frontend-design";
import type { ReactNode } from "react";
import { SessionStatusChip } from "@/components/status/SessionStatusChip";
import type { EvalRunDetailController } from "./useEvalRunDetailController";
import styles from "./EvalRunDetailChrome.module.css";

// 상세 뷰의 두 진입점이 함께 쓰는 요소다. 두 진입점은 Results 창에서 바로 여는 패널과 비교 패널
// 위에 겹치는 중첩 패널이다. 상태 표시와 취소 가능 여부는 셸이 아니라 run 이 정하므로 한 곳에 둔다.

export function EvalRunDetailHeaderActions({
  controller,
}: {
  controller: EvalRunDetailController;
}): ReactNode {
  return (
    <div className={styles.headerActions}>
      <SessionStatusChip status={controller.effectiveStatus} />
      {controller.canCancel ? (
        <IconButton
          text={controller.actionPending ? "취소 중…" : "취소"}
          size="sm"
          variant="surface"
          disabled={controller.actionPending}
          onClick={controller.cancel}
        />
      ) : null}
    </div>
  );
}

// 셸 본문 grid 의 직접 자식이라 셸이 행 간격을 정한다. 래퍼를 두면 그 간격이 깨진다.
export function EvalRunDetailNotice({
  controller,
}: {
  controller: EvalRunDetailController;
}): ReactNode {
  if (controller.actionError === null) {
    return null;
  }
  return <p className={styles.errorNotice}>{controller.actionError}</p>;
}
